import { render, staticRenderFns } from "./UserSapCodes.vue?vue&type=template&id=33a32644&scoped=true"
import script from "./UserSapCodes.vue?vue&type=script&lang=js"
export * from "./UserSapCodes.vue?vue&type=script&lang=js"
import style0 from "./UserSapCodes.vue?vue&type=style&index=0&id=33a32644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a32644",
  null
  
)

export default component.exports